import { j as m } from "./jsx-runtime-3tyXYecC.mjs";
import { forwardRef as T } from "react";
import { F as x } from "./flex-Cc3osQLf.mjs";
import { T as j } from "./typography-Bj_iezxf.mjs";
import { m as u } from "./tss-DN0acMKN.mjs";
import { g as b } from "./generate-fabric-classes-CDFy9xEs.mjs";
import { B as h } from "./Box-B5hjovXR.mjs";
const S = u()(({ palette: n, typography: e, spacing: t }, { AdornedProps: o, ContentProps: r, verticalLayout: a }) => {
  let i = t(o ? o.spacing : 1);
  return a && (i = "0"), {
    root: {
      color: n.gray[1e3],
      fontSize: e.large.fontSize,
      fontWeight: e.fontWeightSemibold,
      lineHeight: e.medium.lineHeight,
      margin: "0 0 20px"
    },
    noMargin: {
      marginBottom: 0
    },
    adornment: {
      display: "flex",
      // prevents inline child from having gap at bottom
      fill: n.primary.main,
      marginRight: i
    },
    content: {
      marginLeft: t(r ? r.spacing : 0)
    }
  };
}), d = b("AdornedText", ["root", "adornment", "content"]), w = T(
  ({
    AdornedProps: n,
    adornment: e,
    biId: t,
    children: o,
    classes: r,
    ContentProps: a,
    hasMargin: i = !0,
    typographyProps: g,
    verticalLayout: c,
    ...l
  }, p) => {
    const { classes: s, cx: f } = S(
      { AdornedProps: n, ContentProps: a, verticalLayout: c },
      { props: { classes: r } }
    );
    return /* @__PURE__ */ m.jsxs(
      x,
      {
        alignItems: "center",
        className: f(s.root, { [s.noMargin]: !i }, d.root),
        "data-bi-id": t,
        flexDirection: c ? "column" : "row",
        justifyContent: c ? "center" : "flex-start",
        ref: p,
        ...l,
        "data-fabric-component": l["data-fabric-component"] ? `${l["data-fabric-component"]} AdornedText` : "AdornedText",
        children: [
          e ? /* @__PURE__ */ m.jsx(h, { className: f(s.adornment, d.adornment), ...n, children: e }) : null,
          /* @__PURE__ */ m.jsx(x, { className: f(s.content, d.content), ...a, children: typeof o == "string" ? /* @__PURE__ */ m.jsx(j, { ...g, children: o }) : o })
        ]
      }
    );
  }
);
export {
  w as A
};
//# sourceMappingURL=adorned-text-ngaJgM_T.mjs.map
